var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgValidated(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:1.6999;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M62.53,61.68v2.93c0,1.96-1.59,3.54-3.54,3.54H20.35c-1.96,0-3.54-1.59-3.54-3.54V15.38 c0-1.96,1.59-3.54,3.54-3.54h29.23c0.94,0,1.84,0.37,2.51,1.04l9.42,9.42c0.67,0.67,1.04,1.57,1.04,2.51v10.11"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M49.57,20.3v2.13c0,1.31,1.06,2.36,2.36,2.36h10.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 49.57,
    y1: 16.34,
    x2: 49.57,
    y2: 11.84
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.26,57.52l1.01-3.36c0.3-1.01,1.23-1.69,2.28-1.69h14.28c1.05,0,1.98,0.69,2.28,1.69l1.01,3.36"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.86,48.11c0.34-0.48,0.72-0.93,1.14-1.36c4.07-4.07,10.66-4.07,14.73,0s4.07,10.66,0,14.73 s-10.66,4.07-14.73,0c-2.66-2.67-3.58-6.41-2.76-9.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.37,61.64c4.15,0,7.52-3.36,7.52-7.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.37,46.6c-4.15,0-7.52,3.37-7.52,7.52"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.94,59.05c-0.53,0-1.03-0.25-1.36-0.67l-2.84-3.75c-0.57-0.75-0.42-1.81,0.33-2.38s1.81-0.42,2.38,0.33 l1.37,1.81l3.26-5.06c0.51-0.79,1.56-1.02,2.35-0.51c0.79,0.51,1.02,1.56,0.51,2.35l-4.57,7.11c-0.3,0.47-0.81,0.76-1.36,0.78 C31.98,59.05,31.96,59.05,31.94,59.05z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.42,61.68h20.55c1.15,0,2.09-0.93,2.09-2.09l0,0c0-1.15-0.93-2.09-2.09-2.09H48.42 c-1.15,0-2.09,0.93-2.09,2.09l0,0C46.33,60.75,47.26,61.68,48.42,61.68z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M64.19,42.88l0.39-2.47c0.58-3.62-2.22-6.9-5.89-6.9s-6.47,3.28-5.89,6.9l1.92,12.05h7.94l0.91-5.71"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 33.77,
    y1: 24.8,
    x2: 45.58,
    y2: 24.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 23.96,
    y1: 29.85,
    x2: 55.38,
    y2: 29.85
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 23.96,
    y1: 34.9,
    x2: 48.02,
    y2: 34.9
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidated);
export default __webpack_public_path__ + "static/media/validated.054d4e4c1d9466cfa820a20ddbf67c48.svg";
export { ForwardRef as ReactComponent };